var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"12","md":"12","sm":"12"}},[_c('Analysis',{on:{"rowSelected":function($event){return _vm.rowSelected($event)}}})],1),_c('v-col',{attrs:{"cols":"12","lg":"12","md":"12","sm":"12"}},[_c('AnalysisDetail',{attrs:{"RmnID":_vm.RmnID}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }